import React from 'react';
import { Link} from 'react-router-dom';
import {Carousel} from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

export default class Header extends React.Component
{
    render()
    {
        return (
            <div className="lmsheader">
                <div className="lmstopnavbar">
                    {this.props.loaded ?
                        this.props.authenticated ? (
                            <div>
                                <div className="lmstopnavitem lmstopnavitem-right">
                                    <Link to="/Cart"><img src="/images/cart-white.png" alt="[ Cart ]" />
                                        <div className="pricecontainer">
                                            My Cart
                                        </div>
                                    </Link>
                                </div>
                                <div className="lmstopnavitem lmstopnavitem-right">
                                    <a href="/" onClick={(e) => this.props.onLogout()}>Logout</a>
                                </div>
                            </div>
                        ) : (
                                <div>
                                    <div className="lmstopnavitem lmstopnavitem-left">
                                        <Link to="/">
                                            <img src="/images/course-white.png" alt="[ Catalog ]" />
                                            <div className="pricecontainer">
                                                Course Catalog
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="lmstopnavitem lmstopnavitem-right">
                                        <Link to="/Cart"><img src="/images/cart-white.png" alt="[ Cart ]" />
                                            <div className="pricecontainer">
                                                My Cart
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="lmstopnavitem lmstopnavitem-right">
                                        <Link to="/Login">Login</Link>
                                    </div>
                                    <div className="lmstopnavitem lmstopnavitem-right">
                                        <Link to="/Register">Register</Link>
                                    </div>
                                </div>
                    ) : (
                        <div>
                            <span></span>
                        </div>
                    )}
                </div>
                <div className="lmsbanner">
                    <div className="lmstopleft">
                        <h1 className="lmsheadertxt">Safety Check</h1>
                        <div className="lmspoweredby">Powered by<br />
                            <a className="bodylink" href="https://www.csem.com">
                                <img src="/images/logo.png" alt="CSEM" />
                            </a>
                        </div>
                    </div>
                    <div className="lmstopright">
                        <div style={{float: "right", width: "762px"}}>
                            <Carousel showArrows={true} showThumbs={false} showStatus={false} infiniteLoop={true} autoPlay={true} interval={10000}>
                                <div>
                                    <img src="/images/CSEMSlides/slide1.png" className="trbannerimg lmsbannerimg" alt="[ Slide 1 ]"  />
                                </div>
                                <div>
                                    <img src="/images/CSEMSlides/slide2.png" className="trbannerimg lmsbannerimg" alt="[ Slide 2 ]"  />
                                </div>
                                <div>
                                    <img src="/images/CSEMSlides/slide3.png" className="trbannerimg lmsbannerimg" alt="[ Slide 3 ]" />
                                </div>
                            </Carousel>
                        </div>
                    </div>
                    <div className="lmsclear">
                        <span></span>
                    </div>
                </div>
                <div className="lmsticker">
                    <div className="ticker-wrap">
                        <div className="ticker">
                            <div className="tickerItem">
                                Welcome to the Saftey Check Learning Management System.
                            </div>
                            <div className="tickerItem">
                                Content Authors: Did you know that you can use the import functionality to convert your test questions and 
                                powerpoint presentations to Scorm 1.2 format for portability to other systems? <a href="/">Click here to learn more.</a>
                            </div>
                            <div className="tickerItem">
                                The Saftey Check Learning Management System allows companies and organizations to customize look and feel 
                                to match their branding and style guidelines. <a href="/">Click here to learn more.</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/general/header.js